import React from 'react';

const MaintenancePage = () => {
  return (
    <div
      style={{
        fontFamily: "'Roboto', sans-serif",
        background: "linear-gradient(to bottom, #333, #777)",
        color: "#d3d3d3",
        textAlign: "center",
        margin: 0,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundAttachment: "fixed",
      }}
    >
      <div>
        <h1 style={{ fontSize: "3rem", color: "white" }}>Under Maintenance</h1>
        <img
          src="https://cult.qpcore.com/logoCult.svg"
          alt="Maintenance Logo"
          style={{
            maxWidth: "150px",
            height: "auto",
            margin: "20px 0",
            borderRadius: "10px",
          }}
        />
        <p style={{ fontSize: "1.2rem", margin: "10px" }}>
          Сайт на ремонті, скоро в ефірі. 
          <br />
          Дякуємо, що чекаєш!
        </p>
        <p style={{ fontSize: "1rem", margin: "10px", color: "#bdbdbd" }}>
          Щодо інших проєктів, дивитись{" "}
          <a
            href="https://qpcore.com"
            style={{
              color: "white",
              textDecoration: "underline",
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "none")}
            onMouseOut={(e) => (e.target.style.textDecoration = "underline")}
          >
            основний веб-додаток
          </a>.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;

